export default __webpack_public_path__ + "static/SRUS SBDS - Especification Del Producto y Datos Técnicos-632bbf9c9416408094403f6520b2d8f8.pdf";